import Sync from '@croco/sync';
import di from 'dependeny-injection'

/**
 * データ登録
 *
 * @package     chiyo-co
 * @author      Kenichi Kashiwagi <pod@cro-co.co.jp>
 */
class Api extends Sync {
  constructor() {
    super();
    this.api = "/api/v1/setting/";
  }

  async buy() {
    let url = this.api + 'oneshot/buy';
    let data = {};
    let payload = await this.post(url, data);
    if (!payload.result) {
      this.trigger('bought', false, payload.message);
      return false;
    }
    this.trigger('bought', true, payload.data);
    return true;
  }

  async items() {
    let url = this.api + 'oneshot/items';
    let data = {};
    let payload = await this.post(url, data);
    if (!payload.result) {
      return false;
    }
    this.trigger('fetched:items', payload.data);
    return payload.data;
  }

} // class Noticemail
const api = new Api();

export {
  api
};